module.exports = __webpack_public_path__ + "static/triangle_two-5876f8fe091649f930082fb12807e890.png";